import { ApiUrlModel } from "../../../chat/entities/chatApiUrl-model";


const updateProfessionalProfile="updateProfessionalProfile";
const updateProfessionalInfo="updateProfessionalInfo";//new
const getProfessionalProfile="getProfessionalProfile";
const searchConsultation = "searchConsultation";
const create_consultation = "create_consultation";//new
const getCountryList="getCountryList";
const getStateByCountryId="getStatesByCountryId";
const getCityByStateId="getCitiesByStateId";
const getCityByCityId="getCityByCityId";
const getStateByStateId="getStateByStateId";
const getBasicProfileInfo="getBasicProfileInfo";//new
const getFullProfileDetails="getFullProfileDetails";//new
const getConsultationDetailsById="getConsultationDetailsById";
const bookConsultationById="bookConsultationById";

const updateMyConsultation="updateMyConsultation";
const createChargingRate="createChargingRate";
const updateChargingRate="updateChargingRate";
const getTagList="getTagList";
const getBuyerOrderList="getBuyerOrderList";

const apiSearchStudyField="apiSearchStudyField";
const apiSearchDegree="apiSearchDegree";
const addSellerEducationalInfo="addSellerEducationalInfo";
const getEducatoinalProfileInfo="getEducatoinalProfileInfo";
const getStudyFieldInfoById="getStudyFieldInfoById";
const getDegreeInfoById="getDegreeInfoById";
const apiSearchLanguage="apiSearchLanguage"; //new
const addUserLanguage="addUserLanguage";
const addUpdateUserLanguages="addUpdateUserLanguages" //new
const addUserCertification="addUserCertification";
const addUserPortFolio="addUserPortFolio";
const addUserArticle="addUserArticle";
const myArticlesList="myArticlesList";
const deleteArticle="deleteArticle";
const UpdateArticle="UpdateArticle";
const getUserCertification="getUserCertification";
const getUserPortfolio="getUserPortfolio";
const getTags="getTags";
const getUserLanguage="getUserLanguage";//new
const deleteUserLanguage="deleteUserLanguage"; // new
const deleteSellerEducationInfo="deleteSellerEducationInfo";
const deleteUserCertification="deleteUserCertification";
const deleteUserPortFolio="deleteUserPortFolio";
const notificationList="notificationList";
const addWishList="addWishList";
const myWishList="myWishList";
const removeFromWishList="removeFromWishList";
const searchConsultationsByAdvanceFilters="searchConsultationsByAdvanceFilters";
const searchprofileConsultations="searchprofileConsultations";//new
const addCommentToArticle="addCommentToArticle";
const getCommentsByArticle="getCommentsByArticle";
const addLikeDislike="addLikeDislike";
const updateAboutUsProfile="updateAboutUsProfile";
const apiAllLanguage="apiAllLanguage";
const addImagesAndVideosToGallery="addImagesAndVideosToGallery";
const deleteUserGalleryImageVideo="deleteUserGalleryImageVideo";
const publishConsultationsById="publishConsultationsById";

const getProfileSummary="getProfileSummary";
const getUserLanguageByLangId="getUserLanguageByLangId";
const updateUserLanguage="updateUserLanguage";
const getEducationDetailByEduId="getEducationDetailByEduId";
const updateEducationDetails="updateEducationDetails";
const updateCertificateDetail="updateCertificateDetail";
const getUserCertificationById="getUserCertificationById";
const getUserPortfolioById="getUserPortfolioById";
const updatePortFolioDetail="updatePortFolioDetail";
// const getConsultationReviews="getConsultationReviews";
const getSellerOrders="getSellerOrders";
const getArticlesById="getArticlesById";
const deleteConsultation="deleteConsultation";
const removeItem="removeItem";
const myDeletedConsultations="myDeletedConsultations";
const addPortFolioImages="addPortFolioImages";
const restoreConsultation="restoreConsultation";
const getAllConsultant="getAllConsultant";
const getAllArtilces="getAllArtilces";
const deletePortFolioImage="deletePortFolioImage";
const getUpcommingOrders="getUpcommingOrders";
const getUpcommingOrdersV2="getUpcommingOrdersV2";
const updateArticleComment="updateArticleComment";
const deleteComment="deleteComment";
const getAllPlans="getAllPlans";
const getcardList="getcardList";
const CreateCustomerCard="CreateCustomerCard";
const deleteCreditCard="deleteCreditCard";
const updateCardDefault="updateCardDefault";
const markAllNotificationRead="markAllNotificationRead";
const getConsultant="getConsultant";
const getCustomerBillings="getCustomerBillings";
const getUserWallet= "getUserWallet"
const addMoneyToWallet="addMoneyToWallet"
const walletTransactions="walletTransactions"
const getWalletTransactionsV2="getWalletTransactionsV2"
const getPaymentTransactionsV2="getPaymentTransactionsV2"
const getUserSettings ="getUserSettings"
const addUpdateSettings ="addUpdateSettings"
const getOnlineStatus ="getOnlineStatus"
const getAllConsultationByUser = "getAllConsultationByUser";
const getEmojiReactions= "getEmojiReactions";
const addEmojiReaction = "addEmojiReaction";
const updateEmojiReaction ="updateEmojiReaction";
const getArticlesByUserId ="getArticlesByUserId";
const addBankDetails="addBankDetails";
const getBankDetails="getBankDetails";
const deleteBankDetails="deleteBankDetails";
const getProfessionalProfileById="getProfessionalProfileById";
const AddUserAvailability="AddUserAvailability";
const UpdateUserAvailability="UpdateUserAvailability";
const GetMyAvailability="GetMyAvailability";
const UpdateUserConsultationDenomination = "UpdateUserConsultationDenomination";
const withdrawalMoneyFromWallet = "withdrawalMoneyFromWallet";
const GetSocialPlatforms = "GetSocialPlatforms"; // new
const addUserSocialLink = "AddUserSocialLink";// new
const getUserSocialLinksByUserId = "GetUserSocialLinksByUserId";// new
const updateUserSocialLinksByUserId = "updateUserSocialLinksByUserId";//new
const deleteUserSocialLink = "DeleteUserSocialLink";// new
const GetAvaibilityByUserId = "GetAvaibilityByUserId"
const getAllCountriesMaster = "getAllCountriesMaster";
const getAllCategoriesMaster = "getAllCategoriesMaster";//new
const getConsultationsOnTopCategories = "getConsultationsOnTopCategories";//new
const getTopCategories = "getTopCategories";//new
const getSkillsByCategoryId = "getSkillsByCategoryId";//new
const GetSkillById = "GetSkillById";//new
const addUpdateUserExperiences='addUpdateUserExperiences'// new
const getAllUserExperiences='getAllUserExperiences'// new
const deleteUserExperience = 'deleteUserExperience'// new
const addUpdateSlots = 'addUpdateSlots'// new
const getUserSlots='getUserSlots'//new
const AddTimeAwaySlot = "AddTimeAwaySlot"; //new
const UpdateTimeAwaySlot = "UpdateTimeAwaySlot"; //new
const GetTimeAwaySlot = "GetTimeAwaySlot"; //new
const DeletedTimeAwaySlot = "DeletedTimeAwaySlot"; //new
const GetUpcommingTimeAwaySlot = "GetUpcommingTimeAwaySlot"; //new
const AddVacationSlot = "AddVacationSlot"; //new
const UpdateVacationSlot = "UpdateVacationSlot"; //new
const GetVacationSlot = "GetVacationSlot"; //new
const DeletedVacationSlot = "DeletedVacationSlot"; //new
const GetUpcommingVacationSlot = "GetUpcommingVacationSlot"; //new
const updateTimezone = "updateTimezone"//new
const AddUpdateSettings = "AddUpdateSettings"//new
const GetUserSettings = "GetUserSettings"//new
const GetUserSettingsget = "GetUserSettingsget"//new
const googleCalendarConnect = "googleCalendarConnect"//new
const googleCalendarStatus = "googleCalendarStatus"//new
const googleCalendarDisconnect = "googleCalendarDisconnect"//new
const googleCalendarCalendars = "googleCalendarCalendars"//new
const googleCalendarSelectCalendar = "googleCalendarSelectCalendar"//new
const googleCalendarBusy = "googleCalendarBusy"//new
const googleCalendarCreateMeetLink = "googleCalendarCreateMeetLink"//new
const googleCalendarSyncBooking = "googleCalendarSyncBooking"//new
const updateBasicConsultation = 'updateBasicConsultation'//new
const getDefaultConsultationImage = 'getDefaultConsultationImage'//new
const updateLiveConsultation = 'updateLiveConsultation'//new
const getConsultation='getConsultation' //new
const getSubCategoryByCategoryId = 'getSubCategoryByCategoryId'//new
const getallSubCategoryByCategoryId = 'getallSubCategoryByCategoryId'//new
const updateConsultationCategory = 'updateConsultationCategory'//new
const getConsultationsUserCategory = 'getConsultationsUserCategory';//new - GET when removing category
const updateConsultationCategories = 'updateConsultationCategories';//new - PUT to update categories
const addDenomination = 'addDenomination'//new
const updateDenomination = 'updateDenomination'//new
const getAllDenomination = 'getAllDenomination'//new
const deleteDenomination = 'deleteDenomination'//new
const updateConsultationStatus = 'updateConsultationStatus'//new
const getConsultationDetail = 'getConsultationDetail'//new
const getSimilarConsultations = 'getSimilarConsultations'//new
const getConsultationUserProfile = 'getConsultationUserProfile'//new
const getCountryNameByID = 'getCountryNameByID'//new
const getWalletDetail = 'getWalletDetail'//new
const getCardDetail = 'getCardDetail'//new
const addCard = 'addCard'//new
const bookConsultation = 'bookConsultation'//new
const bookConsultationV2 = 'bookConsultationV2'//new - api/Booking/v2
const getFreeBookingCount = 'getFreeBookingCount'// GET /api/Booking/{userId}/free-booking-count
const paymentCheckout = 'paymentCheckout'//new - api/Payment/checkout
const getBookingByConsultantId = 'getBookingByConsultantId'//new
const getConsultantSchedule = 'getConsultantSchedule'//new
const getPayfirmTokens="getPayfirmTokens";//new
const createSetupIntent="createSetupIntent";//new - Stripe payment
const getStripeCards="getStripeCards";//new - Stripe payment
const cardMandate="cardMandate";//new - India card mandate (POST /api/card/mandate)
const cardMandateStatus="cardMandateStatus";//new - India mandate status (GET /api/card/mandate/status)
const deleteStripeCard="deleteStripeCard";//new - Stripe payment
const setStripeCardDefault="setStripeCardDefault";//new - Stripe payment
const retryOrderPaymentIntent="retryOrderPaymentIntent";
const retryOrderUpiPaymentIntent="retryOrderUpiPaymentIntent";
const createProjectCardPaymentIntent="createProjectCardPaymentIntent";
const createProjectUpiPaymentIntent="createProjectUpiPaymentIntent";
const retryProjectPaymentIntent="retryProjectPaymentIntent";
const retryProjectUpiPaymentIntent="retryProjectUpiPaymentIntent";
const completeProjectPaymentIntent="completeProjectPaymentIntent";

const getUserDetailsById = "getUserDetailsById"; //new
const getBookingTransactionsByBookingId = "getBookingTransactionsByBookingId"; //new
const getConsultationDetailsById_UserBio = "getConsultationDetailsById_UserBio"; //new
const getScheduleById_UserBio = "getScheduleById_UserBio"; //new
const rescheduleBooking = "rescheduleBooking"; //new
const markBookingCompleted = "markBookingCompleted"; //new
const finalizeFreeBooking = "finalizeFreeBooking"; // POST /api/Booking/{bookingId}/Finalize
const clientRequirement = "clientRequirement"; //new
const bookingHistory = "bookingHistory"; // GET BookingHistory/{id} — no POST /History
const getClientBookings = "getClientBookings"; //new
const bookingStatus = "bookingStatus"; //new
const getConsultantBookings = "getConsultantBookings"; //new
const getClientBookingsByUserId = "getClientBookingsByUserId"; //new
const getUpcomingClientBookings  ="getUpcomingClientBookings"//new
const getUpcomingConsultantBookings  ="getUpcomingConsultantBookings"//new
const getProjectConsultant = "getProjectConsultant"; //new
const checkActiveConsultation = "checkActiveConsultation"; //new
const setBookingAvailability = "setBookingAvailability"; //new - POST /api/Booking/{bookingId}/Availability
const requestRescheduleBooking = "requestRescheduleBooking"; //new - POST /api/Booking/{orderId}/RequestReschedule
const closeAndInitiatePayoutBooking = "closeAndInitiatePayoutBooking"; //new - POST /api/Booking/{orderId}/CloseAndInitiatePayout
const requestRefundBooking = "requestRefundBooking"; //new - POST /api/Booking/{orderId}/RequestRefund
const dispute = "dispute"; // POST /api/dispute - Raise dispute (e.g. ConsultantNoShow)
const complaint = "complaint"; //new - POST /api/complaint
const reportIssue = "reportIssue"; // POST /api/complaint/report-issue
const complaintReasons = "complaintReasons"; //new - GET /api/complaint/reasons?entityId={bookingOrderId}
const complaintReasonsCatalog = "complaintReasonsCatalog"; //new - GET /api/complaint/reasons (reference – all buyer/seller reasons)
const complaintByEntity = "complaintByEntity"; //new - GET /api/complaint/entity/{entityId}/1

const addRatingReview = "addRatingReview"; // new
const getConsultationReviews_Rating = "getConsultationReviews_Rating"; // new 
const getdetailId = "getdetailId"; // new
const getdenominationId = "getdenominationId"; // new
//SETTING 
const updateBasicProfileInfo="updateBasicProfileInfo";//new
const updateBasicProfessionalInfo="updateBasicProfessionalInfo";//new
const updateProfileImage="updateProfileImage";//new
const updateUserCategorySkills="updateUserCategorySkills";//new
const changePassword = 'changePassword'//new
const VerifyEmail = 'VerifyEmail'//new
const VerifyUser = 'VerifyUser'//new
const VerifyNewEmail = 'VerifyNewEmail'//new
const UpdateEmail = 'UpdateEmail'//new
const notification = 'notification'//new
const setCardDefault = 'setCardDefault' //new
const deleteCard = 'deleteCard'//new
const changePlan="changePlan";//new
const getActivePlan='getActivePlan'//new
const getBillingHistoryClient='getBillingHistoryClient'//new
const getReferralData = 'getReferralData'; //new
const validateReferralCode = 'validateReferralCode'; //new
const verifyReferralCode = 'verifyReferralCode'; //new
const updateReferralCode = 'updateReferralCode'; //new
const getReferralEarningDetails = 'getReferralEarningDetails'; //new
const getReferralProgress = 'getReferralProgress'; //new
const getPaymentHistoryDetailsById='getPaymentHistoryDetailsById'//new
const getProjectEarnings='getProjectEarnings'//new
const getProjectInvestments='getProjectInvestments'//new
const isEmailExist='isEmailExist'//new
const getWithdrawalLogs='getWithdrawalLogs'//new
const addRecipient='addRecipient'//new
const getRecipientDetail='getRecipientDetail'//new
const markAccountPrimary='markAccountPrimary'//new
const withdrawalRequest='withdrawalRequest'//new
const withdrawDetail='withdrawDetail'//new
const checkActiveRequest='checkActiveRequest'//new
const addEditBillingAddress='addEditBillingAddress'//new
const getBillingAddress='getBillingAddress'//new
const taxBillingAddress='taxBillingAddress'//new
// ===== PROJECT API ENDPOINTS (Buyer only) =====
const createProject = "createProject"; //new - POST
const updateProject = "updateProject"; //new - PUT
const getProjectDetails = "getProjectDetails"; //new - GET
const getmainprojectdetail = "getmainprojectdetail"; //new - GET - /api/projectdetail
const getProjectFiles = "getProjectFiles"; //new - GET - /api/projectdetail/files
const getProjectSubmissionFiles = "getProjectSubmissionFiles"; //new - GET - /api/projectdetail/submission-files
const getProjectMilestones = "getProjectMilestones"; //new - GET - /api/projectdetail/milestones
const getMilestoneTimeline = "getMilestoneTimeline"; //new - GET - /api/projectdetail/milestone-timeline
const getMilestoneProjectSummary = "getMilestoneProjectSummary"; //new - GET - /api/projects/milestones/{milestoneId}/summary
const getProjectTimeline = "getProjectTimeline"; //new - GET - /api/projectdetail/project-timeline
const getMilestoneDeliverables = "getMilestoneDeliverables"; //new - GET - /api/projectdetail/milestone-deliverables
const submitMilestoneDeliverables = "submitMilestoneDeliverables"; //new - POST - /api/projectdetail/milestone-deliverables
const updateMilestoneDeliverables = "updateMilestoneDeliverables"; //new - PUT - /api/projectdetail/milestone-deliverables
const milestoneApprovePaymentRating = "milestoneApprovePaymentRating"; //new - PUT - /api/projectdetail/milestone-approve-payment-rating
const milestoneRatingClient = "milestoneRatingClient"; //new - PUT - /api/projectdetail/milestone-rating-client
const updateProjectMilestone = "updateProjectMilestone"; //new - PUT
const milestoneOnChange = "milestoneOnChange"; //new - delete
const assignProject = "assignProject"; //new - PUT
const milestoneApprovePay = "milestoneApprovePay"; //new - PUT - /api/projectdetail/milestone-approve-pay
const getConsultantProjects = "getConsultantProjects"; //new - POST
const getClientProjects = "getClientProjects"; //new - POST
const getClientProjectCount = "getClientProjectCount"; //new - GET
const getConsultantProjectCount = "getConsultantProjectCount"; //new - GET
const projectrestoreToDraft = "projectrestoreToDraft"; //new - POST
const deleteProject = "deleteProject"; //new - DELETE
const updateProjectStatus = "updateProjectStatus"; //new - PUT
const moveProjectToDraft = "moveProjectToDraft"; //new - PUT
const assignNewConsultant = "assignNewConsultant"; //new - PUT
const milestoneStartRequest = "milestoneStartRequest"; //new - PUT
const milestoneEndDate = "milestoneEndDate"; //new - PUT

// ===== COMMON API ENDPOINTS =====
const getProfileByUserId = "getProfileByUserId"; // Profile by User ID - tagline and Skills, About Me, tag
const getProfileSeo = "getProfileSeo"; // Profile SEO by User ID
const getProfileSeoMeta = "getProfileSeoMeta"; // Profile SEO meta by User ID
const getProfileSeoSchema = "getProfileSeoSchema"; // Profile SEO JSON-LD schema by User ID
// const getUserDetails = "getUserDetails"; // User details
const getEducationalQualificationById = "getEducationalQualificationById"; // Education
const getUserLanguageByUserId = "getUserLanguageByUserId"; // Languages
const getUserCertificationByUserId = "getUserCertificationByUserId"; // Certificate
const getUserPortfolioByUserId = "getUserPortfolioByUserId"; // Portfolio
const getBannerImages = "getBannerImages"; // Banner Images
// const getUserSocialLinks = "getUserSocialLinks"; // Social Links
const getUserExperiencesByUserId = "getUserExperiencesByUserId"; // Experience Info
const getUserTotalExperiencesByUserId = "getUserTotalExperiencesByUserId"; // Total Experience in years and months

// ===== CONSULTANT SPECIFIC API ENDPOINTS =====
const getConsultantReviews = "getConsultantReviews"; // Average Rating, 4.5+ count, satisfaction percentage, Reviews list
const getMyConsultationCards = "getMyConsultationCards"; // Get Consultation and denominations
const getallstatusConsultationCards = "getallstatusConsultationCards"; //new
const getConsultantCompletedOrderCount = "getConsultantCompletedOrderCount"; // Completed count (legacy GET)
const getCompletedOrderCount = "getCompletedOrderCount"; // POST — completed count by consultation id list
const getTimeAway = "getTimeAway"; // Slots, Vacations, TimeAway

// ===== CLIENT SPECIFIC API ENDPOINTS =====
const getClientReviews = "getClientReviews"; // Average Rating, 4.5+ count, satisfaction percentage, Reviews list
const getClientCompletedOrderCount = "getClientCompletedOrderCount"; // Completed count

// ===== UPDATE/ADD API ENDPOINTS =====
// Removed duplicate endpoints - using existing ones instead
const FavConsultation='FavConsultation'
const FavConsultant='FavConsultant'
//Dashboard
 const getConsultantRatingStats='getConsultantRatingStats'
 const getClientRatingStats='getClientRatingStats'
const getClientRevenue='getClientRevenue'
const getConsultantRevenue='getConsultantRevenue'
const getConsultantBookingsComparison='getConsultantBookingsComparison'
const getClientBookingsComparison='getClientBookingsComparison'
const ProfileCompletionSummary='ProfileCompletionSummary'
const getStoredResume = "getStoredResume"; //new
const uploadResume = "uploadResume"; //new
const createSearchActivity = "createSearchActivity"; //new
const createSearchActivityResult = "createSearchActivityResult"; //new

// ===== PROFILE PAGE V2 =====
const getProfileMeV2 = "getProfileMeV2";
const getProfileByUserIdV2 = "getProfileByUserIdV2";
const getProfileReviewsV2 = "getProfileReviewsV2";
const updateProfileCoverV2 = "updateProfileCoverV2";
const getProfileBanners = "getProfileBanners";
const updateProfileLocationV2 = "updateProfileLocationV2";
const updateProfileAboutV2 = "updateProfileAboutV2";
const updateBuyerProfile = "updateBuyerProfile";
const getClientOrganization = "getClientOrganization";
const updateClientOrganization = "updateClientOrganization";

const virtco_gateway_path = process.env.REACT_APP_URL;

/**
 * Analytics APIs: gateway currently 301-redirects to the analytics host.
 * Browsers convert redirected POST → GET (405). Call analytics host directly.
 * Prefer REACT_APP_ANALYTICS_URL; else derive from gateway hostname (*-gateway-* → *-analytics-*).
 */
const virtco_analytics_path = (() => {
  const explicit = (process.env.REACT_APP_ANALYTICS_URL || "").replace(/\/$/, "");
  if (explicit) return explicit;
  const gateway = (virtco_gateway_path || "").replace(/\/$/, "");
  if (gateway.includes("gateway")) {
    return gateway.replace(/gateway/gi, "analytics");
  }
  return gateway;
})();
// const virtco_order=process.env.REACT_APP_VIRTCO_ORDER;
// const virtco_notification=process.env.REACT_APP_VIRTCO_NOTIFICATION;
// const virtco_master = process.env.REACT_APP_VIRTCO_MASTERS;
// const virtco_sts = process.env.REACT_APP_VIRTCO_STS_URL
// const virtco_payment=process.env.REACT_APP_PAYMENT_URL

const ApiUrl = (url:string,param = new ApiUrlModel("")) =>{  
    switch (url) {
      case ProfileCompletionSummary:
        return `${virtco_gateway_path}/api/Profile/ProfileCompletionSummary/${param.id}`;
      case getProfessionalProfile:
        return `${virtco_gateway_path}/api/Profile/GetProfessionalProfile`;
      case updateProfessionalProfile:
        return `${virtco_gateway_path}/api/Profile/UpdateProfessionalProfile`; //hold   not in use
        case updateProfessionalInfo:
        return `${virtco_gateway_path}/api/Profile/UpdateProfessionalProfile`;//new  in use
      case searchConsultation:
        return `${virtco_gateway_path}/api/consultation/search`;
      case getCountryList:
        return `${virtco_gateway_path}/api/Masters/GetCountries`;
      case getStateByCountryId:
        return `${virtco_gateway_path}/api/Masters/GetStatesByCountryId/${param.id}`;
      case getCityByStateId:
        return `${virtco_gateway_path}/api/Masters/GetCitiesByStateId/${param.id}`;
      case getStateByStateId:
        return `${virtco_gateway_path}/api/Masters/GetState/${param.id}`;
      case getCountryNameByID:
        return `${virtco_gateway_path}/api/Masters/GetCountry/${param.id}`;//new
      case getCityByCityId:
        return `${virtco_gateway_path}/api/Masters/GetCity/${param.id}`;
      case getBasicProfileInfo:
        return `${virtco_gateway_path}/api/Auth/GetBasicProfile`;//new
      case getFullProfileDetails:
        return `${virtco_gateway_path}/api/Profile/GetFullProfileDetails`;//new
      case getDegreeInfoById:
        return `${virtco_gateway_path}/api/Masters/GetDegree/${param.id}`;
      case getStudyFieldInfoById:
        return `${virtco_gateway_path}/api/Masters/GetStudyField/${param.id}`;
      case apiSearchLanguage:
        return `${virtco_gateway_path}/api/Masters/GetLanguages?keyword=${param.keyword}`;
      case apiAllLanguage:
        return `${virtco_gateway_path}/api/Masters/GetAllLanguages`;
      case apiSearchStudyField:
        return `${virtco_gateway_path}/api/Masters/GetStudyFields?keyword=${param.keyword}`;
      case apiSearchDegree:
        return `${virtco_gateway_path}/api/Masters/GetAllDegrees`;
      case bookConsultationById:
        return `${virtco_gateway_path}/api/Orders/BookConsultation`;
      case getWalletDetail:
        return `${virtco_gateway_path}/api/wallets` //new
      // case getWalletTransaction:
      //   return `${virtco_gateway_path}/api/Wallet/Transactions` //new
       case getPayfirmTokens:
        return `${virtco_gateway_path}/api/Payment/AccessToken`//new;
      case createSetupIntent:
        return `${virtco_gateway_path}/api/card/create-setup-intent`;//new - Stripe
      case getStripeCards:
        return `${virtco_gateway_path}/api/card`;//new - Stripe
      case cardMandate:
        return `${virtco_gateway_path}/api/card/mandate`;//new - India mandate (REACT_APP_STRIPE_PAYMENTS_ORIGIN / REACT_APP_PAYMENTS_API_ORIGIN)
      case cardMandateStatus:
        return `${virtco_gateway_path}/api/card/mandate/status`;//new - mandate status after SetupIntent / 3DS
      case deleteStripeCard:
        return `${virtco_gateway_path}/api/card/${param.id}`;//new - Stripe
      case setStripeCardDefault:
        return `${virtco_gateway_path}/api/card/${param.id}/set-default`;//new - Stripe
      case retryOrderPaymentIntent:
        return `${virtco_gateway_path}/api/card/orders/${param.id}/intent/retry`;
      case retryOrderUpiPaymentIntent:
        return `${virtco_gateway_path}/api/card/orders/${param.id}/intent/upi/retry`;
      case createProjectCardPaymentIntent:
        return `${virtco_gateway_path}/api/card/intent/project`;
      case createProjectUpiPaymentIntent:
        return `${virtco_gateway_path}/api/card/intent/project/upi`;
      case retryProjectPaymentIntent:
        return `${virtco_gateway_path}/api/card/projects/${param.id}/intent/retry`;
      case retryProjectUpiPaymentIntent:
        return `${virtco_gateway_path}/api/card/projects/${param.id}/intent/upi/retry`;
      case completeProjectPaymentIntent:
        return `${virtco_gateway_path}/api/card/projects/${param.id}/complete`;
        case addCard:
          return `${virtco_gateway_path}/api/Card` //new
        case getCardDetail:
          return `${virtco_gateway_path}/api/Card/GetCards` //new
        case bookConsultation:
        return `${virtco_gateway_path}/api/Booking`//new
      case bookConsultationV2:
        return `${virtco_gateway_path}/api/Booking`//new
      case getFreeBookingCount:
        return `${virtco_gateway_path}/api/Booking/${param.id}/free-booking-count`; //new
      case paymentCheckout:
        return `${virtco_gateway_path}/api/Payment/checkout`//new
      case getBookingByConsultantId:
        
        return `${virtco_gateway_path}/api/Booking/Consultant/${param.id}`;//new
      case create_consultation:
        return `${virtco_gateway_path}/api/Consultation`;//new
      case addDenomination:
        return `${virtco_gateway_path}/api/Consultation/Denomination`;//new
       case getAllDenomination:
        return `${virtco_gateway_path}/api/Consultation/GetAllDenomination/${param.id}`;//new
      case updateDenomination:
        return `${virtco_gateway_path}/api/Consultation/Denomination/${param.id}`;//new
      case deleteDenomination:
        return `${virtco_gateway_path}/api/Consultation/Denomination/${param.id}`;//new
      case updateConsultationStatus:
        return `${virtco_gateway_path}/api/Consultation/UpdateStatus/${param.id}`;//new
      case getConsultantSchedule:
        return `${virtco_gateway_path}/api/Schedule/GetAll/${param.id}`;//new
      // case create_consultation:
      //   return `${virtco_gateway_path}/api/profile/createconsultation`;
      case updateBasicConsultation:
        return `${virtco_gateway_path}/api/Consultation/${param.id}`//new
      case getDefaultConsultationImage:
        return `${virtco_gateway_path}/api/Resume/consultation-banners`;//new
        case updateLiveConsultation:
        return `${virtco_gateway_path}/api/Consultation/LiveEdit/${param.id}`//new
      case getConsultationDetail:
        return `${virtco_gateway_path}/api/Consultation/${param.id}`//new
      case getSimilarConsultations:
        return `${virtco_gateway_path}/api/Consultation/${param.id}/SimilarConsultations`//new
      case getConsultationUserProfile:
        return `${virtco_gateway_path}/api/Consultation/${param.id}/UserProfile`//new
       case updateConsultationCategory:
        return `${virtco_gateway_path}/api/Consultation/Category/${param.id}`//new
      case getConsultationsUserCategory:
        return `${virtco_gateway_path}/api/Consultation/ConsultationsUserCategory/${param.id}`;//new
      case updateConsultationCategories:
        return `${virtco_gateway_path}/api/Consultation/Categories`;//new
       case getConsultation:
        return `${virtco_gateway_path}/api/Consultation/GetDetails/${param.id}`//new
      case getConsultationDetailsById:
        return `${virtco_gateway_path}/api/Profile/GetConsultation/${param.id}`;

      case updateMyConsultation:
        return `${virtco_gateway_path}/api/Profile/UpdateConsultation/${param.id}`;
      case createChargingRate:
        return `${virtco_gateway_path}/api/Profile/CreateConsultationDenomination`;
      case updateChargingRate:
        return `${virtco_gateway_path}/api/Profile/UpdateConsultationDenomination/${param.id}`;
      case getTagList:
        return `${virtco_gateway_path}/api/tags/gettags?keyword=${param.id}`;
      case getBuyerOrderList:
        return `${virtco_gateway_path}/api/Orders/MyConsultationOrders`;
      case addSellerEducationalInfo:
        return `${virtco_gateway_path}/api/Profile/AddUpdateEducationalQualifications`;
      case getEducatoinalProfileInfo:
        return `${virtco_gateway_path}/api/Profile/GetEducationalQualification`;
      case addUserLanguage:
        return `${virtco_gateway_path}/api/Profile/AddUserLanguage`;
      case addUpdateUserLanguages:
        return `${virtco_gateway_path}/api/Profile/AddUpdateUserLanguages`;
      case addUserCertification:
        return `${virtco_gateway_path}/api/Profile/AddUpdateUserCertifications`;
      case addUserPortFolio:
        return `${virtco_gateway_path}/api/Profile/AddUpdateUserPortfolios`;
      case addUserArticle:
        return `${virtco_gateway_path}/api/Articles/AddArticle`;
      case myArticlesList:
        return `${virtco_gateway_path}/api/Articles/myArticles`;
      case deleteArticle:
        return `${virtco_gateway_path}/api/Articles/DeleteArticle/${param.id}`;
      case UpdateArticle:
        return `${virtco_gateway_path}/api/Articles/UpdateArticle/${param.id}`;
      case removeItem:
        return `${virtco_gateway_path}/api/Articles/RemoveItem/${param.id}`;
      case getUserCertification:
        return `${virtco_gateway_path}/api/Profile/GetUserCertification`;
      case getUserPortfolio:
        return `${virtco_gateway_path}/api/Profile/GetUserPortfolio`;
      case getTags:
        return `${virtco_gateway_path}/api/Tags/GetTags?keyword=${param.keyword}`;
      case getUserLanguage:
        return `${virtco_gateway_path}/api/Profile/GetUserLanguage`;
      case deleteUserLanguage:
        return `${virtco_gateway_path}/api/Profile/DeleteUserLanguage/${param.id}`;
      case deleteSellerEducationInfo:
        return `${virtco_gateway_path}/api/Profile/DeleteEducationalQualification/${param.id}`;
      case deleteUserCertification:
        return `${virtco_gateway_path}/api/Profile/DeleteUserCertification/${param.id}`;
      case deleteUserPortFolio:
        return `${virtco_gateway_path}/api/Profile/DeletePortfolio/${param.id}`;
      case notificationList:
        return `${virtco_gateway_path}/api/Notification/GetAllNotifications`;
      case markAllNotificationRead:
        return `${virtco_gateway_path}/api/Notification/MarkReadAllNotifications`;
      case addWishList:
        return `${virtco_gateway_path}/api/WishList/AddItem`;
      
      case removeFromWishList:
        return `${virtco_gateway_path}/api/WishList/RemoveItem/${param.id}`;

        case searchprofileConsultations:  //new
          return `${virtco_gateway_path}/api/Consultation/Search`; //new

      case searchConsultationsByAdvanceFilters:
        return `${virtco_gateway_path}/api/Consultation/AdvanceSearch`;
      case getCommentsByArticle:
        return `${virtco_gateway_path}/api/Comment/GetCommentReplyByPost/${param.id}`;
      case addLikeDislike:
        return `${virtco_gateway_path}/api/Comment/AddLikeDislike`;
      case addCommentToArticle:
        return `${virtco_gateway_path}/api/Comment/AddComment`;
      case updateAboutUsProfile:  
        return `${virtco_gateway_path}/api/Profile/UpdateProfessionalProfile`; // not in use
      case addImagesAndVideosToGallery:
        return `${virtco_gateway_path}/api/Profile/AddImagesAndVideosToGallery`;
      case deleteUserGalleryImageVideo:
        return `${virtco_gateway_path}/api/Profile/DeleteUserGalleryImageVideo/${param.id}`;
      case publishConsultationsById:
        return `${virtco_gateway_path}/api/Profile/UpdateConsultationStatus/${param.id}`;
      // case getConsultationReviews:
      //   return `${virtco_gateway_path}/api/Profile/GetConsultationReviews/${param.id}`;
      case getSellerOrders:
        return `${virtco_gateway_path}/api/Orders/SellerOrders/${param.id}`;
      case deleteConsultation:
        return `${virtco_gateway_path}/api/Consultation/${param.id}`;//NEW
      case myDeletedConsultations:
        return `${virtco_gateway_path}/api/Consultation/ArchivedConsultation`;//used
      case restoreConsultation:
        return `${virtco_gateway_path}/api/Consultation/RestoreArchived/${param.id}`;//used
      case getProfileSummary:
        return `${virtco_gateway_path}/api/Profile/GetFullProfile`;
      case getUserLanguageByLangId:
        return `${virtco_gateway_path}/api/Profile/GetUserLanguageByLangId/${param.id}`;
      case updateUserLanguage:
        return `${virtco_gateway_path}/api/Profile/UpdateUserLanguage`;
      case getEducationDetailByEduId:
        return `${virtco_gateway_path}/api/Profile/GetUserEducationByEduId/${param.id}`;
      case updateEducationDetails:
        return `${virtco_gateway_path}/api/Profile/UpdateEducationalQualification`;
      case updateCertificateDetail:
        return `${virtco_gateway_path}/api/Profile/UpdateUserCertification`;
      case getUserCertificationById:
        return `${virtco_gateway_path}/api/Profile/GetUserCertificationById/${param.id}`;
      case getUserPortfolioById:
        return `${virtco_gateway_path}/api/Profile/GetUserPortfolioById/${param.id}`;
      case updatePortFolioDetail:
        return `${virtco_gateway_path}/api/Profile/UpdateUserPortfolio`;
      case UpdateUserConsultationDenomination:
        return `${virtco_gateway_path}/api/Profile/DeleteConsultationDenomination/${param.id}`; 
      case getArticlesById:
        return `${virtco_gateway_path}/api/Articles/GetArticle/${param.id}`;
     
      case getcardList:
        return `${virtco_gateway_path}/api/Payments/GetCardList`;
      case CreateCustomerCard:
        return `${virtco_gateway_path}/api/Payments/CreateCustomer`;
      case deleteCreditCard:
        return `${virtco_gateway_path}/api/Payments/DeleteCard`;
      case updateCardDefault:
        return `${virtco_gateway_path}/api/Payments/UpdateDefaultCard`;
      case getConsultant:
        return `${virtco_gateway_path}/api/Profile/GetConsultant/${param.id}`;
      
      
      case getCustomerBillings:
        return `${virtco_gateway_path}/api/Plans/GetCustomerInvoices`;
      case getUserWallet:
        return `${virtco_gateway_path}/api/Wallet/GetUserWallet`;
      case addMoneyToWallet:
        return `${virtco_gateway_path}/api/Wallet/AddMoneyToWallet`;
      case withdrawalMoneyFromWallet:
        return `${virtco_gateway_path}/api/Wallet/AddWithdrawalRequest`;
     
      case getUserSettings:
        return `${virtco_gateway_path}/api/Settings/GetUserSettings`;
      case addUpdateSettings:
        return `${virtco_gateway_path}/api/Settings/AddUpdateSettings`;
      case getOnlineStatus:
        return `${virtco_gateway_path}/api/Constants/GetOnlineStatus`;
      case getAllConsultationByUser:
        return `${virtco_gateway_path}/api/Consultation/GetAllByUser/${param.id}`;
      case AddUserAvailability:
          return `${virtco_gateway_path}/api/Availability`;
      case UpdateUserAvailability:
          return `${virtco_gateway_path}/api/Availability/${param.id}`;
      case GetMyAvailability:
          return `${virtco_gateway_path}/api/Availability/MyAvailability`;
      case GetAvaibilityByUserId:
        return `${virtco_gateway_path}/api/Availability/GetAvailabilityByUserId/${param?.id}`

        case AddTimeAwaySlot:
          return `${virtco_gateway_path}/api/Schedule/AddTimeAway`; //new
      case UpdateTimeAwaySlot:
          return `${virtco_gateway_path}/api/Schedule/UpdateTimeAway`; //new
      case GetTimeAwaySlot:
          return `${virtco_gateway_path}/api/Schedule/GetTimeAway/${param?.id}`; //new
          case DeletedTimeAwaySlot:
            return `${virtco_gateway_path}/api/Schedule/DeleteTimeAway/${param?.id}`; //new
      case GetUpcommingTimeAwaySlot:
        return `${virtco_gateway_path}/api/Schedule/GetUpcommingTimeAway`; //new

        case AddVacationSlot:
          return `${virtco_gateway_path}/api/Schedule/AddVacation`; //new
      case UpdateVacationSlot:
          return `${virtco_gateway_path}/api/Schedule/UpdateVacation`; //new
      case GetVacationSlot:
          return `${virtco_gateway_path}/api/Schedule/GetVacation/${param?.id}`; //new
          case DeletedVacationSlot:
            return `${virtco_gateway_path}/api/Schedule/DeleteVacation/${param?.id}`; //new
      case GetUpcommingVacationSlot:
        return `${virtco_gateway_path}/api/Schedule/GetUpcommingVacation`; //new

        case AddUpdateSettings        :
          return `${virtco_gateway_path}/api/Settings/AddUpdateSettings`; //new
      case GetUserSettings:
          return `${virtco_gateway_path}/api/Settings/GetUserSettings`; //new
      case GetUserSettingsget:
          return `${virtco_gateway_path}/api/Settings/GetUserSettingsId/${param?.id}`; //new
      case googleCalendarConnect:
          return `${virtco_gateway_path}/api/GoogleCalendar/Connect`;
      case googleCalendarStatus:
          return `${virtco_gateway_path}/api/GoogleCalendar/Status`;
      case googleCalendarDisconnect:
          return `${virtco_gateway_path}/api/GoogleCalendar/Disconnect`;
      case googleCalendarCalendars:
          return `${virtco_gateway_path}/api/GoogleCalendar/Calendars`;
      case googleCalendarSelectCalendar:
          return `${virtco_gateway_path}/api/GoogleCalendar/SelectCalendar`;
      case googleCalendarBusy:
          return `${virtco_gateway_path}/api/GoogleCalendar/Busy/${param.id}`;
      case googleCalendarCreateMeetLink:
          return `${virtco_gateway_path}/api/GoogleCalendar/CreateMeetLink`;
      case googleCalendarSyncBooking:
          return `${virtco_gateway_path}/api/GoogleCalendar/SyncBooking`;

      case getAllArtilces:
        return `${virtco_gateway_path}/api/Articles/GetArticles`;
      case getAllConsultant:
        return `${virtco_gateway_path}/api/Profile/TopConsultantsV2`;
      case addPortFolioImages:
        return `${virtco_gateway_path}/api/Profile/AddPortfolioImages`;
      case deletePortFolioImage:
        return `${virtco_gateway_path}/api/Profile/DeletePortfolioImage/${param.id}`;
      case getUpcommingOrders:
        return `${virtco_gateway_path}/api/Orders/UpcomingConsultations`;
      case updateArticleComment:
        return `${virtco_gateway_path}/api/Comment/UpdateComment`;
      case deleteComment:
        return `${virtco_gateway_path}/api/Comment/DeleteComment/${param.id}`;
      case getUpcommingOrdersV2:
        return `${virtco_gateway_path}/api/Orders/UpcomingConsultationsV2`;

        

      case getEmojiReactions: 
        return `${virtco_gateway_path}/api/Comment/GetEmojiReaction?EntityId=${param.id}&EntityType=${param.type}`;
      case addEmojiReaction: 
        return `${virtco_gateway_path}/api/Comment/AddEmojiReaction`;
      case updateEmojiReaction: 
        return `${virtco_gateway_path}/api/Comment/UpdateEmojiReaction`;
      case getArticlesByUserId:
        return `${virtco_gateway_path}/api/Articles/GetArticlesByUserId`;
      case addBankDetails: 
        return `${virtco_gateway_path}/api/Payout/AddBankAccount`;  
      case getBankDetails: 
        return `${virtco_gateway_path}/api/Payout/MyBankAccounts`;  
      case deleteBankDetails: 
        return `${virtco_gateway_path}/api/Payout/DeleteBankAccount/${param.id}`;  
      case getProfessionalProfileById: 
        return `${virtco_gateway_path}/api/Profile/GetProfessionalProfileById/${param.id}`;
      case GetSocialPlatforms:
        return `${virtco_gateway_path}/api/Masters/GetSocialPlatforms`;  
      case addUserSocialLink:
        return `${virtco_gateway_path}/api/Profile/AddUserSocialLink`;  
      case getUserSocialLinksByUserId:
        return `${virtco_gateway_path}/api/Profile/GetUserSocialLinks/${param.id}`; //new
      case updateUserSocialLinksByUserId:
        return `${virtco_gateway_path}/api/Profile/UpdateUserSocialLink/${param.id}`; 
      case deleteUserSocialLink:
        return `${virtco_gateway_path}/api/Profile/DeleteUserSocialLink/${param.id}`;
      case getAllCountriesMaster:
        return `${virtco_gateway_path}/api/Masters/GetCountries`;
      case getAllCategoriesMaster:
        return `${virtco_gateway_path}/api/Masters/GetCategories`;//new
      case getTopCategories:
        return `${virtco_gateway_path}/api/Consultation/TopCategories`;//new
      case getConsultationsOnTopCategories:
        return `${virtco_gateway_path}/api/Consultation/TopRated`;//new
        case getallSubCategoryByCategoryId:
        return `${virtco_gateway_path}/api/Masters/GetSubCategoryByCategoryIds`;//new
      case getSubCategoryByCategoryId:
        return `${virtco_gateway_path}/api/Masters/GetSubCategoryByCategoryId/${param.id}`;//new
      case getSkillsByCategoryId:
        return `${virtco_gateway_path}/api/Masters/GetSkillsByCategoryId/${param.id}`;//new
      case GetSkillById:
        return `${virtco_gateway_path}/api/Masters/GetSkillsByCategoryId/${param.id}`;
        case addUpdateUserExperiences:
          return `${virtco_gateway_path}/api/Profile/AddUpdateUserExperiences`;
        case getAllUserExperiences:
          return `${virtco_gateway_path}/api/Profile/GetAllUserExperiences`;
      case deleteUserExperience:
        return `${virtco_gateway_path}/api/Profile/DeleteUserExperience/${param.id}`;
      case addUpdateSlots:
        return `${virtco_gateway_path}/api/Schedule/AddUpdateSlots`;
       case getUserSlots:
        return `${virtco_gateway_path}/api/Schedule/GetUserSlots`;
       case updateTimezone:
        return `${virtco_gateway_path}/api/Auth/UpdateTimezone`;
      case getUserDetailsById: //new
        return `${virtco_gateway_path}/api/Auth/GetUserDetails/${param.id}`;//new
      case getBookingTransactionsByBookingId: //new
        return `${virtco_gateway_path}/api/Payment/BookingTransactions/${param.id}`;
      case getConsultationDetailsById_UserBio: //new
        return `${virtco_gateway_path}/api/Consultation/GetDetails/${param.id}`;
      case getScheduleById_UserBio: //new
        return `${virtco_gateway_path}/api/Schedule/GetAll/${param.id}`;
      case rescheduleBooking: //new
        return `${virtco_gateway_path}/api/Booking/Reschedule`;
      case markBookingCompleted: //new
        return `${virtco_gateway_path}/api/Booking/MarkCompleted`;
      case finalizeFreeBooking: // POST /api/booking/{orderId}/Finalize
        return `${virtco_gateway_path}/api/booking/${param.id}/Finalize`;
      case clientRequirement: //new
        return `${virtco_gateway_path}/api/Booking/ClientRequirement`;
      case bookingHistory: // GET /api/Booking/BookingHistory/{id} (POST /api/Booking/History removed)
        return `${virtco_gateway_path}/api/Booking/BookingHistory/${param.id}`;
      case getClientBookings: //new
        return `${virtco_gateway_path}/api/Booking/GetClientBookings`;
      case bookingStatus: //new
        return `${virtco_gateway_path}/api/Booking/Status`;
      case getConsultantBookings: //new
        return `${virtco_gateway_path}/api/Booking/GetConsultantBookings`;
      case getClientBookingsByUserId: //new
        return `${virtco_gateway_path}/api/Booking/Client/${param.id}`;
      case setBookingAvailability: //new - POST /api/Booking/{bookingId}/Availability
        return `${virtco_gateway_path}/api/Booking/${param.id}/Availability`;
      case requestRescheduleBooking: //new - POST /api/Booking/{orderId}/RequestReschedule
        return `${virtco_gateway_path}/api/Booking/${param.id}/RequestReschedule`;
      case closeAndInitiatePayoutBooking: //new - POST /api/Booking/{orderId}/CloseAndInitiatePayout
        return `${virtco_gateway_path}/api/Booking/${param.id}/CloseAndInitiatePayout`;
      case requestRefundBooking: //new - POST /api/Booking/{orderId}/RequestRefund
        return `${virtco_gateway_path}/api/Booking/${param.id}/RequestRefund`;
      case dispute:
        return `${virtco_gateway_path}/api/dispute`;
      case complaint: //new - POST /api/complaint
        return `${virtco_gateway_path}/api/complaint`;
      case reportIssue:
        return `${virtco_gateway_path}/api/complaint/report-issue`;
      case complaintReasons: //new - GET /api/complaint/reasons?entityId={bookingOrderId}
        return `${virtco_gateway_path}/api/complaint/reasons?entityId=${param.id}`;
      case complaintReasonsCatalog: //new - GET /api/complaint/reasons
        return `${virtco_gateway_path}/api/complaint/reasons`;
      case complaintByEntity: //new - GET /api/complaint/entity/{entityId}/1
        return `${virtco_gateway_path}/api/complaint/entity/${param.id}/1`;

      case addRatingReview:
        return `${virtco_gateway_path}/api/RatingReview/AddRatingReview`;//new
      case getConsultationReviews_Rating:
        return `${virtco_gateway_path}/api/RatingReview/GetConsultationReviews/${param.id}`;//new
        case getdetailId:
        return `${virtco_gateway_path}/api/Booking/Detail/${param.id}`;//new
        case getdenominationId:
        return `${virtco_gateway_path}/api/Consultation/GetByDenomination/${param.id}`;//new

      // ===== COMMON API ENDPOINTS =====
      case getProfileByUserId:
        return `${virtco_gateway_path}/api/Profile/ProfileByUserId/${param.id}`; //new
      case getProfileSeo:
        return `${virtco_gateway_path}/api/ProfileSeo/${param.id}`;
      case getProfileSeoMeta:
        return `${virtco_gateway_path}/api/ProfileSeo/meta/${param.id}`;
      case getProfileSeoSchema:
        return `${virtco_gateway_path}/api/ProfileSeo/schema/${param.id}`;
      // case getUserDetails:
      //   return `${virtco_gateway_path}/api/Auth/GetUserDetails/${param.id}`; //new
      case getEducationalQualificationById:
        return `${virtco_gateway_path}/api/Profile/EducationalQualificationById/${param.id}`; //new
      case getUserLanguageByUserId:
        return `${virtco_gateway_path}/api/Profile/UserLanguageByUserId/${param.id}`; //new
      case getUserCertificationByUserId:
        return `${virtco_gateway_path}/api/Profile/UserCertificationByUserId/${param.id}`; //new
      case getUserPortfolioByUserId:
        return `${virtco_gateway_path}/api/Profile/UserPortfolioByUserId/${param.id}`; //new
      case getBannerImages:
        return `${virtco_gateway_path}/api/Profile/GetBannerImages/${param.id}`; //new
      case getProfileBanners:
        return `${virtco_gateway_path}/api/Profile/profile-banners`;
      // case getUserSocialLinks:
      //   return `${virtco_gateway_path}/api/Profile/GetUserSocialLinks/${param.id}`; //new
      case getUserExperiencesByUserId:
        return `${virtco_gateway_path}/api/Profile/UserExperiencesByUserId/${param.id}`; //new
      case getUserTotalExperiencesByUserId:
        return `${virtco_gateway_path}/api/Profile/UserTotalExperiencesByUserId/${param.id}`; //new

      // ===== CONSULTANT SPECIFIC API ENDPOINTS =====
      case getConsultantReviews:
        return `${virtco_gateway_path}/api/RatingReview/ConsultantReviews/${param.id}`; //new
      case getMyConsultationCards:
        return `${virtco_gateway_path}/api/Consultation/GetByUserId`; //new
      case getConsultantCompletedOrderCount:
        return `${virtco_gateway_path}/api/Booking/GetConsultantCompletedOrderCount/${param.id}`; //new
      case getCompletedOrderCount:
        return `${virtco_gateway_path}/api/Booking/GetCompletedOrderCount`;
      case getTimeAway:
        return `${virtco_gateway_path}/api/Schedule/GetTimeAway/${param.id}`; //new

      // ===== CLIENT SPECIFIC API ENDPOINTS =====
      case getClientReviews:
        return `${virtco_gateway_path}/api/RatingReview/ClientReviews/${param.id}`; //new
      case getClientCompletedOrderCount:
        return `${virtco_gateway_path}/api/Booking/GetClientCompletedOrderCount/${param.id}`; //new

      // ===== UPDATE/ADD API ENDPOINTS =====
      // Removed duplicate cases - using existing ones instead

      //myconsultations
      case getallstatusConsultationCards:
        return `${virtco_gateway_path}/api/Consultation/Me`; //new

      // Settings api
      case updateBasicProfileInfo:
        return `${virtco_gateway_path}/api/Auth/UpdateBasicProfile`;//new
        // new api for update basic professional info and contact info
      case updateBasicProfessionalInfo:
        return `${virtco_gateway_path}/api/Profile/UpdateBasicProfessionalProfile`;//new
      case changePassword:
        return `${virtco_gateway_path}/api/Auth/ChangePassword `;//new
      case updateProfileImage:
        return `${virtco_gateway_path}/api/Auth/UpdateProfilePhoto`;//new
      case updateUserCategorySkills:
        return `${virtco_gateway_path}/api/Profile/UpdateProfessionalCategorySkills`;//new
      case VerifyEmail:
        return `${virtco_gateway_path}/api/Auth/VerifyEmail`;//new
      case VerifyUser:
        return `${virtco_gateway_path}/api/Auth/VerifyUser`;//new
        case VerifyNewEmail:
        return `${virtco_gateway_path}/api/Auth/VerifyNewEmail`; //new
        case isEmailExist:
          return `${virtco_gateway_path}/api/Auth/IsEmailExist?email=${encodeURIComponent(param.email)}`; //new on vedika's suggession passing email as a query parameter
      case UpdateEmail:
        return `${virtco_gateway_path}/api/Auth/UpdateEmail`;//new
      case notification:
        return `${virtco_gateway_path}/api/Settings`;//new
      case setCardDefault:
        return `${virtco_gateway_path}/api/Card/SetDefault`;//new
      case deleteCard:
        return `${virtco_gateway_path}/api/Card/DeleteCard`;//new
       case getAllPlans:
        return `${virtco_gateway_path}/api/Plans/GetPlans`;//new
      case changePlan:
        return `${virtco_gateway_path}/api/subscription/change-plan`;//new
       case walletTransactions:
        return `${virtco_gateway_path}/api/wallets/Transactions`;//new
       case getWalletTransactionsV2:
        return `${virtco_gateway_path}/api/v2/wallets/transactions`;
       case getPaymentTransactionsV2:
        return `${virtco_gateway_path}/api/v2/payment/transactions`;
         case getBillingHistoryClient:
        return `${virtco_gateway_path}/api/Payment/GetAllTransactions`;//new
        case getPaymentHistoryDetailsById:
          return `${virtco_gateway_path}/api/Payment/Transactions/${param.id}`;//new
        case getProjectEarnings:
          return `${virtco_gateway_path}/api/payment/earnings-project`;//new
        case getProjectInvestments:
          return `${virtco_gateway_path}/api/Payment/investments-project`;//new
      case getActivePlan:
        return `${virtco_gateway_path}/api/Plans/GetActivePlanByUser/${param.id}`;//new
       case getClientRatingStats:
        return `${virtco_gateway_path}/api/RatingReview/GetClientRatingStats/${param.id}`;//new
        case getConsultantRatingStats:
        return `${virtco_gateway_path}/api/RatingReview/GetConsultantRatingStats/${param.id}`;//new
        case getConsultantRevenue:
          return `${virtco_gateway_path}/api/wallets/GetRevenueConsultant/${param.id}`//new
        case getClientRevenue:
          return `${virtco_gateway_path}/api/wallets/GetRevenueClient/${param.id}`//new
        case getConsultantBookingsComparison:
          return `${virtco_gateway_path}/api/Booking/GetConsultantBookingsComparison/${param.id}`//new
        case getClientBookingsComparison:
          return `${virtco_gateway_path}/api/Booking/GetClientBookingsComparison/${param.id}`//new
          case myWishList:
        return `${virtco_gateway_path}/api/wishlist/mywishlist`;
        case FavConsultant:
        return `${virtco_gateway_path}/api/WishList/Consultants`;//new
        case FavConsultation:
        return `${virtco_gateway_path}/api/WishList/Consultations`;//new
       case getUpcomingClientBookings: //new
        return `${virtco_gateway_path}/api/Booking/GetUpcomingClientBookings`;
         case getUpcomingConsultantBookings: //new
        return `${virtco_gateway_path}/api/Booking/GetUpcomingConsultantBookings`;//new
      case getProjectConsultant: //new
        return `${virtco_gateway_path}/api/Booking/ProjectConsultant`;//new
      case checkActiveConsultation: //new
        return `${virtco_gateway_path}/api/Booking/check-active-consultation/${param.id}`;//new
      case getReferralData: //new
        return `${virtco_gateway_path}/api/Referral`;//new
      case validateReferralCode: //new
        return `${virtco_gateway_path}/api/Referral/ValidateCode/${param.id}`;//new
      case verifyReferralCode: //new
        return `${virtco_gateway_path}/api/Referral/VerifyReferralCode/${param.id}`;//new
      case updateReferralCode: //new
        return `${virtco_gateway_path}/api/Referral?Id=${param.id}`;//new
      case getReferralEarningDetails: //new
        return `${virtco_gateway_path}/api/Referral/EarningDetails`;//new
      case getReferralProgress: //new
        return `${virtco_gateway_path}/api/Referral/Progress`;//new
      case getWithdrawalLogs: //new
        return `${virtco_gateway_path}/api/payout/withdrawals`;//new
      case addRecipient: //new
        return `${virtco_gateway_path}/api/payout/accounts`;//new
      case getRecipientDetail: //new
        return `${virtco_gateway_path}/api/payout/accounts`;//new
      case markAccountPrimary: //new
        return `${virtco_gateway_path}/api/Payout/mark-account-primary`;//new
      case withdrawalRequest: //new
        return `${virtco_gateway_path}/api/payout/withdrawal`;//new
      case checkActiveRequest: //new
        return `${virtco_gateway_path}/api/payout/withdrawals/active`;//new
         case withdrawDetail: //new
        return `${virtco_gateway_path}/api/payout/withdrawals/${param.id}`;//new
      
      // ===== PROJECT API ENDPOINTS (TalentPool /api/v1/projects) =====
      case createProject: // POST
        return `${virtco_gateway_path}/api/v1/projects`;
      case updateProject: // PUT
        return `${virtco_gateway_path}/api/v1/projects/${param.id}`;
      case getProjectDetails: // GET management edit
        return `${virtco_gateway_path}/api/v1/projects/${param.id}`;
      case getmainprojectdetail: // GET screen overview
        return `${virtco_gateway_path}/api/v1/projects/details/${param.id}`;
      case getProjectFiles: // GET
        return `${virtco_gateway_path}/api/v1/projects/details/${param.id}/files`;
      case getProjectSubmissionFiles: // GET
        return `${virtco_gateway_path}/api/v1/projects/details/${param.id}/submission-files`;
      case getProjectMilestones: // GET
        return `${virtco_gateway_path}/api/v1/projects/details/${param.id}/milestones`;
      case getMilestoneTimeline: // GET
        return `${virtco_gateway_path}/api/v1/projects/milestones/${param.id}/timeline`;
      case getMilestoneProjectSummary: // GET — milestone project summary for payment history
        return `${virtco_gateway_path}/api/v1/projects/milestones/${param.id}/summary`;
      case getProjectTimeline: // GET
        return `${virtco_gateway_path}/api/v1/projects/details/${param.id}/timeline`;
      case getMilestoneDeliverables: // GET
        return `${virtco_gateway_path}/api/v1/projects/milestones/deliverables?milestoneId=${param.id}`;
      case submitMilestoneDeliverables: // POST
        return `${virtco_gateway_path}/api/v1/projects/milestones/deliverables`;
      case updateMilestoneDeliverables: // PUT
        return `${virtco_gateway_path}/api/v1/projects/milestones/deliverables`;
      case milestoneApprovePaymentRating: // PUT
        return `${virtco_gateway_path}/api/v1/projects/milestones/approve-payment-rating`;
      case milestoneRatingClient: // PUT
        return `${virtco_gateway_path}/api/v1/projects/milestones/rating-client`;
      case milestoneApprovePay: // PUT
        return `${virtco_gateway_path}/api/v1/projects/milestones/approve-pay`;
      case updateProjectMilestone: // PUT
        return `${virtco_gateway_path}/api/v1/projects/${param.id}/milestones`;
      case assignProject: // PUT
        return `${virtco_gateway_path}/api/v1/projects/${param.id}/assignment`;
      case milestoneOnChange: // DELETE
        return `${virtco_gateway_path}/api/v1/projects/${param.id}/milestone-changes`;
      case getConsultantProjects: // POST
        return `${virtco_gateway_path}/api/v1/projects/dashboard/consultant`;
      case getClientProjects: // POST
        return `${virtco_gateway_path}/api/v1/projects/dashboard/client`;
      case getClientProjectCount: // GET
        return `${virtco_gateway_path}/api/v1/projects/dashboard/count/client`;
      case getConsultantProjectCount: // GET
        return `${virtco_gateway_path}/api/v1/projects/dashboard/count/consultant`;
      case projectrestoreToDraft: // POST
        return `${virtco_gateway_path}/api/v1/projects/${param.id}/restore-draft`;
      case deleteProject: // DELETE
        return `${virtco_gateway_path}/api/v1/projects/${param.id}`;
      case updateProjectStatus: // PUT — projectId in path
        return `${virtco_gateway_path}/api/v1/projects/${param.id}/status`;
      case moveProjectToDraft: // PUT
        return `${virtco_gateway_path}/api/v1/projects/${param.id}/revert-draft`;
      case assignNewConsultant: // PUT
        return `${virtco_gateway_path}/api/v1/projects/${param.id}/assign-consultant`;
      case milestoneStartRequest: // PUT
        return `${virtco_gateway_path}/api/v1/projects/milestones/${param.id}/start-request`;
      case milestoneEndDate: // PUT
        return `${virtco_gateway_path}/api/v1/projects/milestones/${param.id}/end-date?endDate=${param.keyword}`;
        case addEditBillingAddress: //new - PUT
        return `${virtco_gateway_path}/api/card/billing-address`; 
        case getBillingAddress: //new - PUT
        return `${virtco_gateway_path}/api/card/billing-address`;
        case taxBillingAddress:
            return `${virtco_gateway_path}/api/card/tax/billing-address`;
      case getStoredResume: //new - GET
        return `${virtco_gateway_path}/api/Resume`; //new
      case uploadResume: //new - POST
        return `${virtco_gateway_path}/api/Resume/upload`; //new
      case createSearchActivity: //new - POST (analytics host — avoid gateway 301 POST→GET)
        return `${virtco_analytics_path}/api/v1/search-activities`; //new
      case createSearchActivityResult: //new - POST (analytics host — avoid gateway 301 POST→GET)
        return `${virtco_analytics_path}/api/v1/search-activities/results`; //new
      case getProfileMeV2:
        return `${virtco_gateway_path}/api/v2/profile/me`;
      case getProfileByUserIdV2:
        return `${virtco_gateway_path}/api/v2/profile/${param.id}`;
      case getProfileReviewsV2:
        return `${virtco_gateway_path}/api/v2/profile/${param.id}/reviews`;
      case updateProfileCoverV2:
        return `${virtco_gateway_path}/api/v2/profile/cover`;
      case updateProfileLocationV2:
        return `${virtco_gateway_path}/api/v2/profile/location`;
      case updateProfileAboutV2:
        return `${virtco_gateway_path}/api/v2/profile/about`;
      case updateBuyerProfile:
        return `${virtco_gateway_path}/api/Profile/UpdateBuyerProfile`;
      case getClientOrganization:
        return `${virtco_gateway_path}/api/v1/onboarding/client/organization`;
      case updateClientOrganization:
        return `${virtco_gateway_path}/api/v1/onboarding/client/organization`;
      default:
        return "";
    }   
}
export default ApiUrl;
